import { twRounded } from './style/rounded'

export const getRoundedClasses = (roundedOptions: keyof typeof twRounded) => {
  switch (typeof roundedOptions) {
    case 'boolean': {
      return twRounded.md
    }
    case 'string': {
      return twRounded[roundedOptions]
    }
    default:
      return 'default'
  }
}

export default getRoundedClasses
